module.exports = __webpack_public_path__ + "img/rusa.6ba3a001.png";